export { IdentityCard } from './IdentityCard';
